import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import SubcategoryPage from "./pages/SubcategoryPage";
import SearchResultsPage from "./pages/SearchResultsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/recursos-digitales" element={<CategoryPage type="digital" />} />
              <Route path="/recursos-impresos" element={<CategoryPage type="printed" />} />
              <Route path="/sitios-interes" element={<CategoryPage type="sites" />} />
              <Route path="/categoria/:type/:subcategoryId" element={<SubcategoryPage />} />
              <Route path="/buscar" element={<SearchResultsPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;